import {Determinant} from "./determinant";
import {TextOperatorType} from "./text-operator";

export class FileDeterminant extends Determinant {

  public operator: TextOperatorType;

}
